import type { z } from 'zod';
import { erroDeContrato } from './erros.js';

/**
 * Confere a resposta do middleware contra o contrato antes de a tela usá-la.
 *
 * O OpenAPI descreve o contrato; ele não garante o corpo que chega. Uma
 * versão adiantada da API, um proxy que reescreve, um campo renomeado — sem
 * esta conferência a tabela renderiza linha inventada e o supervisor decide
 * em cima dela. Falha fechado: erro com código `RESPOSTA_INVALIDA`.
 */
export function analisar<E extends z.ZodTypeAny>(
  schema: E,
  valor: unknown,
  caminho: string,
): z.infer<E> {
  const analisado = schema.safeParse(valor);

  if (!analisado.success) {
    throw erroDeContrato(caminho);
  }

  return analisado.data as z.infer<E>;
}
